import { render, staticRenderFns } from "./index.vue?vue&type=template&id=77b4df3c"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\repository\\india-admin-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('77b4df3c')) {
      api.createRecord('77b4df3c', component.options)
    } else {
      api.reload('77b4df3c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=77b4df3c", function () {
      api.rerender('77b4df3c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ParentView/index.vue"
export default component.exports